import { ColumnDefinition, SortOrder } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { isPayAvailableViaLicense } from 'shared/helpers';

import DelegateCell from './components/DelegateCell/DelegateCell';
import DelegateDateCell from './components/DelegateDateCell/DelegateDateCell';
import { DelegateTimeZoneCell } from './components/DelegateTimeZoneCell/DelegateTimeZoneCell';
import { PermissionsCell } from './components/PermissionsCell/PermissionsCell';
import RoleCell from './components/RoleCell/RoleCell';
import StatusCell from './components/StatusCell/StatusCell';
import TextCell from './components/TextCell/TextCell';
import TFACell from './components/TFACell/TFACell';
import UserMenuCell from './components/UserMenuCell/UserMenuCell';
import { messages } from './UserList.messages';
import { ColumnId, UserRow } from './UserList.types';

export const getTableColumns = (company: selectors.types.ExpandedCompany): ColumnDefinition<UserRow>[] => {
    const hasPayOpenBankingUKBetaFeature = company.betaFeatures.includes(domain.CompanyBetaFeature.PayOpenBankingUK);
    const hasPayLicenceFeature = isPayAvailableViaLicense(company);
    const isXero = company.integration?.integrationType === domain.IntegrationType.Xero;

    return [
        {
            id: ColumnId.Name,
            name: messages.nameColumnText,
            sortable: true,
            minWidth: 200,
            sortOrder: SortOrder.asc,
            value: (item) => <TextCell value={item.displayName} status={item.status} />,
        },
        {
            id: ColumnId.Email,
            name: messages.emailColumnText,
            minWidth: 260,
            sortable: true,
            value: (item) => <TextCell value={item.userEmail} status={item.status} />,
        },
        {
            id: ColumnId.Role,
            name: messages.roleColumnText,
            sortable: true,
            minWidth: 160,
            cellComponent: RoleCell,
        },
        ...(isXero && (hasPayOpenBankingUKBetaFeature || hasPayLicenceFeature)
            ? [
                  {
                      id: ColumnId.Permissions,
                      name: messages.permissionsColumnText,
                      sortable: false,
                      minWidth: 160,
                      cellComponent: PermissionsCell,
                  },
              ]
            : []),
        {
            id: ColumnId.Status,
            name: messages.statusColumnText,
            sortable: true,
            cellComponent: StatusCell,
            minWidth: 100,
        },
        {
            id: ColumnId.TFA,
            name: messages.TFAColumnText,
            sortable: true,
            cellComponent: TFACell,
        },
        {
            id: ColumnId.Delegate,
            name: messages.delegateColumnText,
            sortable: true,
            minWidth: 160,
            cellComponent: DelegateCell,
        },
        {
            id: ColumnId.DelegateDateStart,
            name: messages.delegateDateStartColumnText,
            sortable: true,
            minWidth: 150,
            cellComponent: DelegateDateCell,
        },
        {
            id: ColumnId.DelegateDateEnd,
            name: messages.delegateDateEndColumnText,
            sortable: true,
            minWidth: 150,
            cellComponent: DelegateDateCell,
        },
        {
            id: ColumnId.DelegateTimeZone,
            name: messages.delegateTimeZoneColumnText,
            sortable: false,
            minWidth: 160,
            cellComponent: DelegateTimeZoneCell,
        },
        {
            id: ColumnId.UserMenu,
            sortable: false,
            cellComponent: UserMenuCell,
            width: 40,
        },
    ];
};
